// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recipe-ingredients-module--wrapper--1piH8","information":"recipe-ingredients-module--information--1976F"};